import { render } from "./Header.vue?vue&type=template&id=5c119078&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=5c119078&scoped=true&lang=css"

import exportComponent from "/home/tewky/cloverhitch/pelican/pelican-managers-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c119078"]])

export default __exports__